import React from 'react';

import AfterDoc from '@/components/ui/AfterDoc';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNotQualifyCost = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety, nie możemy podjąć dalszych działań w Twojej sprawie'
      )}
      withButton
      productId={PRODUCT.HOUSE_HOLD}
    >
      <div>
        <p className="body pb-2">
          {i18n.t(
            'Z wstępnej analizy wynika, że koszty postępowania mogłyby przewyższyć możliwą do uzyskania kwotę odszkodowania.'
          )}
        </p>
        <p className="body">
          {i18n.t(
            'Nie chcemy narażać Cię na nieopłacalne postępowanie, dlatego nie możemy podjąć Twojej sprawy. W razie pytań jesteśmy do dyspozycji.'
          )}
        </p>
      </div>
      <p className="body font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </p>
    </AfterDoc>
  );
};

export default ThankYouNotQualifyCost;
